import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { toast } from 'react-hot-toast';
import { Link, useLoaderData } from 'react-router-dom';
import EnrollModal from '../../../components/EnrollModal';
import ScrollToTop from '../../../Shared/ScrollToTop/ScrollToTop';

const CourseDetails = () => {
    const course = useLoaderData()

    const { handleSubmit, register } = useForm()

    const { banner, title, heading, rating, review, lession, hours, host, fees, _id, hostname } = course;

    const current = new Date();
    const currDate = `${current.getDate()}/${current.getMonth() + 1}/${current.getFullYear()}`;

    const [courses, setCourses] = useState([])
    let [isOpen, setIsOpen] = useState(false)
    const [loading, setLoading] = useState(false)

    function closeModal() {
        setIsOpen(false)
    }

    function openModal() {
        setIsOpen(true)
    }

    useEffect(() => {
        //   getCourses()
        axios.get(`${process.env.REACT_APP_API_URL}/cpcourses`)
            .then(res => {
                console.log(res)
                setCourses(res?.data)
            })
            .catch(err => {
                console.log(err)
            })
    }, [])

    const onSubmit = event => {
        const name = event.name
        const email = event.email
        const mobile = event.mobile
        const course = event.course
        setLoading(true)

        const enrollInfo = {
            name: name,
            email: email,
            mobile: mobile,
            course: course,
            date: currDate,
            enroll: false
        }

        console.log(enrollInfo)

        axios.post(`${process.env.REACT_APP_API_URL}/enroll`, enrollInfo)
            .then(res => {
                if (res.data.acknowledged === true) {
                    closeModal()
                    toast.success("Thank You for your Interest")
                    console.log(res.data)
                    setLoading(false)
                }
            })
            .catch(err => {
                console.log(err)
                setLoading(false)
                closeModal()
            })
    }


    return (
        <div className='px-5 max-w-6xl mx-auto xl:px-0 py-11 md:py-16'>
            <ScrollToTop />
            <div className='flex iteems-start gap-7 flex-col md:flex-row relative'>
                <div className="flex-1">
                    <div className="flex items-start">
                        <div>
                            <h3 className='text-xl font-semibold text-4xl mb-5'>{heading}</h3>
                            <p className='text-sm text-gray-500 w-2/3'>Master Figma app to get a job in UI Design, User Interface, User Experience design, Web Design & UX design.</p>
                        </div>
                        <p className='bg-gray-700 p-3 text-xl text-white flex items-center justify-center rounded-full'><i class="fa-regular fa-heart"></i></p>
                    </div>
                    <div className='flex flex-col items-center md:flex-row gap-9 my-7'>
                        <img src={host}
                            alt=""
                            className='h-20 w-20 rounded-full p-2 border'
                        />

                        <div>
                            <h3 className="font-semibold">
                                Created by
                            </h3>
                            <p className='text-sm text-gray-500'>{hostname}</p>
                        </div>
                        <div>
                            <h3 className="font-semibold">
                                Categori
                            </h3>
                            <p className='text-sm text-gray-500'>Education</p>
                        </div>
                        <div>
                            <h3 className="font-semibold">
                                Review
                            </h3>
                            <div className='flex md:items-center flex-col md:flex-row gap-3'>
                                <div className='flex items-center gap-2 text-regal-orange'>
                                    <i class="fa-solid fa-star"></i>
                                    <i class="fa-solid fa-star"></i>
                                    <i class="fa-solid fa-star-half-stroke"></i>
                                    <i class="fa-regular fa-star"></i>
                                    <i class="fa-regular fa-star"></i>
                                </div>
                                {/* <h3 className='text-sm text-gray-500'>5.00 (5.9k+ reviews)</h3> */}
                                <h3 className='text-sm text-gray-500'>{review} ({rating}+ reviews)</h3>
                            </div>
                        </div>
                    </div>
                    <div>
                        <img src={banner}
                            alt=""
                            className='h-56 md:h-96 lg:h-[400px] mb-9 w-full rounded'
                        />
                    </div>
                    <div>
                        <h3 className='text-xl font-semibold mb-5'>Course Description</h3>
                        <p className='text-md text-gray-500 pb-7'>Do you want to become a UI/UX designer but you don't know where to start? This course will allow you to develop your user interface design skills and you can add UI designer to your CV and start getting clients for your skills.</p>
                        <p className='text-md text-gray-500 pb-7'>Do you want to become a UI/UX designer but you don't know where to start? This course will allow you to develop your user interface design skills and you can add UI designer to your CV and start getting clients for your skills.</p>
                    </div>
                    <div>
                        <h3 className='text-xl font-semibold mb-5'>What you'll learn</h3>

                        <div className=" grid-cols-1 md:grid-cols-2 gap-5">
                            {
                                [1, 2, 3, 4, 5, 6, 7, 6, 8, 9].map(i =>
                                    <p className='text6-sm text-gray-500 pb-3'><i class="fa-solid fa-circle-dot pr-3 "></i>designer to your CV and start getting clients for your skills.</p>
                                )
                            }
                        </div>
                    </div>
                    <div>
                        <h3 className='text-xl font-semibold mb-5 mt-7'>Requirements</h3>
                        <p className='text-sm text-gray-500 pb-4'><i class="fa-regular fa-circle-dot pr-2"></i>We do not require any previous experience or pre-defined skills to take this course. A great orientation would be enough to master UI/UX design.</p>
                        <p className='text-sm text-gray-500 pb-4'><i class="fa-regular fa-circle-dot pr-2"></i>A computer with a good internet connection.</p>
                        <p className='text-sm text-gray-500 pb-4'><i class="fa-regular fa-circle-dot pr-2"></i>Adobe Photoshop (OPTIONAL)</p>
                    </div>
                </div>
                <div className="md:w-96 w-full">
                    <div className='px-7 py-9 border'>
                        <div className='flex items-center justify-between'>
                            <div className='flex items-center gap-5'>
                                <h3 className='text-4xl font-semibold'>${fees}</h3>
                                <p className='text-md'>$110</p>
                            </div>
                            <div className='px-3 py-2 bg-blue-200 rounded text-sm text-white rounded'>50% Off</div>
                        </div>
                        <p className='text-red-500 text-md pt-3'><i class="fa-solid fa-stopwatch pr-2"></i>3 days left at this price!</p>
                        <Link onClick={openModal}   ><div className='uppercase w-full h-16 flex items-center justify-center bg-blue-900 hover:bg-blue-800 duration-300 transition ease-in my-6 text-white rounded'>Enroll</div></Link>
                        <div>
                            <div className='flex items-center justify-between  border-b py-3'>
                                <h3 className='font-semibold text text-gray-700'><i class="fa-regular fa-clock pr-2 text-gray-500"></i>Duration</h3>
                                <p className='text-sm text-gray-700'><span className='text-lg'>15</span> weeks</p>
                            </div>
                            <div className='flex items-center justify-between  border-b py-3'>
                                <h3 className='font-semibold text text-gray-700'><i class="fa-solid fa-book-open pr-2 text-gray-500"></i>Lectures</h3>
                                <p className='text-sm text-gray-700'><span className='text-xl'>{lession}lession</span></p>
                            </div>
                            <div className='flex items-center justify-between  border-b py-3'>
                                <h3 className='font-semibold text text-gray-700'><i class="fa-solid fa-book-open-reader text-gray-500 pr-2"></i>Enrolled</h3>
                                <p className='text-sm text-gray-700'><span className='text-lg'>1501</span>students</p>
                            </div>
                            <div className='flex items-center justify-between border-b py-3'>
                                <h3 className='font-medium text text-gray-700'><i class="fa-solid fa-earth-europe pr-2 text-gray-500"></i>Language</h3>
                                <p className='text-sm text-gray-700'><span className='text-lg'>English</span></p>
                            </div>
                            <div className='flex items-center justify-between border-b py-3'>
                                <h3 className='font-medium text text-gray-700'><i class="fa-solid fa-list text-gray-500 pr-2"></i>Skill Level</h3>
                                <p className='text-sm text-gray-700'><span className='text-lg'></span>beginner</p>
                            </div>
                            <div className='flex items-center justify-between border-b py-3'>
                                <h3 className='font-medium text text-gray-700'><i class="fa-solid fa-calendar-days text-gray-500 pr-2"></i>Deadline</h3>
                                <p className='text-sm text-gray-700'><span className='text-lg'>15</span> january <span className='text-lg'>2023</span> </p>
                            </div>
                            <div className='flex items-center justify-between border-b py-3'>
                                <h3 className='font-medium text text-gray-700'><i class="fa-solid fa-ribbon text-gray-500 pr-2"></i>Certificate</h3>
                                <p className='text-sm text-gray-700'><span className='text-lg'>Yes</span></p>
                            </div>
                            <h3 className='text-sky-500 py-5 text-center text-xl cursor-pointer'><i class="fa-solid fa-share-nodes pr-3"></i>Share this course</h3>
                        </div>
                    </div>
                </div>
            </div>
            <div className='md:mt-16 mt-7'>
                <h1 class="text-3xl font-semibold text-center text-gray-800 capitalize lg:text-4xl dark:text-white">
                    Related Course
                </h1>

                <p class=" mt-6 text-center text-gray-500 dark:text-gray-300">
                    Lorem ipsum dolor sit amet consectetur adipisicing
                </p>
            </div>
            <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-7 mt-8 '>
                {
                    courses?.slice(0, 4).map(course =>
                        <Link to={`/coursedetails/${course._id}`}><div className='p-2 border rounded w-full shadow-lg'>
                            <img src={course.banner}
                                className='w-full h-44 rounded'
                                alt="" />
                            <div className='px-2 py-3'>
                                <p className='text-sm-text-gray-500 pb-3'>Development</p>
                                <h3 className='font-semibold pb-5'>would be enough to master UI/UX design</h3>
                                <div className='flex items-center justify-between'>
                                    <h3 className='text-sm text-gray-500'><i class="fa-solid fa-book-open-reader"></i> {course.lession} lessons</h3>
                                    <div className='flex items-center gap-2 text-regal-orange'>
                                        <i class="fa-solid fa-star"></i>
                                        <i class="fa-solid fa-star"></i>
                                        <i class="fa-solid fa-star-half-stroke"></i>
                                        <i class="fa-regular fa-star"></i>
                                        <i class="fa-regular fa-star"></i>
                                    </div>
                                </div>
                            </div>
                        </div></Link>
                    )
                }
            </div>
            <EnrollModal isOpen={isOpen}
                closeModal={closeModal}
                onSubmit={onSubmit}
                handleSubmit={handleSubmit}
                loading={loading}
                register={register}
            />
        </div>
    );
};

export default CourseDetails;